import { storage, db, auth } from "../firebase";
import { signOut, createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { ref, uploadString } from "firebase/storage";
import { startAt, endAt, orderBy, collection, query, where, setDoc, getDocs, doc, getDoc, updateDoc, addDoc, deleteDoc, limit, onSnapshot, writeBatch } from "firebase/firestore";
// Circular by module graph — customFields.js imports getFire/setFire from here.
// Safe because both sides only dereference the other inside function bodies.
import { loadDefinitions, resolveFieldValues } from "../services/customFields";

// ── Timesheet Functions ──

export const getTimesheetsByDate = function (dateStr) {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(
                collection(db, "timesheets"),
                where("date", "==", dateStr),
                orderBy("contractorName", "asc")
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((doc) => {
                arr.push({ ...doc.data(), id: doc.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getTimesheetsByDateRange = function (dateFrom, dateTo) {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(
                collection(db, "timesheets"),
                where("date", ">=", dateFrom),
                where("date", "<=", dateTo),
                orderBy("date", "asc")
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((doc) => {
                arr.push({ ...doc.data(), id: doc.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getTodaysTimesheet = function (contractorId) {
    return new Promise(async (resolve, reject) => {
        try {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const dateStr = `${yyyy}-${mm}-${dd}`;
            const docId = `${dateStr}_${contractorId}`;
            const docRef = doc(db, "timesheets", docId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                resolve({ ...docSnap.data(), id: docSnap.id });
            } else {
                resolve(null);
            }
        } catch (e) {
            reject(e);
        }
    });
}

// Generic Firebase functions
// Get Docs
export const getFire = function (payload) {
    return new Promise(async (resolve, reject) => {
        // A throw from getDoc (permission-denied, offline) would otherwise be
        // swallowed by the async executor and leave this promise unsettled.
        try {
            const docRef = doc(db, payload.collection, payload.doc);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                resolve({ ...docSnap.data(), id: docSnap.id })
            } else {
                reject()
            }
        } catch (e) {
            reject(e)
        }
    })
}

// GEO FIRE Search Docs
export const geoFireUser = function (payload) {
    return new Promise(async (resolve, reject) => {
        console.log("payload.startAt", payload.startAt)
        try{
            const q = query(collection(db,"users"),
            where("geohash", ">=", payload.startAt),
            where("geohash", "<=", payload.endAt),
            orderBy("geohash"));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

// Put Docs
export const putFire = function (payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const docRef = doc(db, payload.collection, payload.doc);
            await updateDoc(docRef, payload.body);
            resolve({ ...payload.body, id: docRef.id })
        } catch (e) {
            reject(e)
        }
    })
}

// Post Docs
export const postFire = function (payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const docRef = await addDoc(collection(db, payload.collection), payload.body);
            resolve({ ...payload.body, id: docRef.id })
        } catch (e) {
            reject(e)
        }
    })
}

export const setFire = function (payload) {
    console.log("utils payload", payload)
    return new Promise(async (resolve, reject) => {
        try {
            await setDoc(doc(db, payload.collection, payload.doc), payload.body, {merge: true});
            resolve({...payload.body, id: payload.doc})
        } catch (e) {
            reject(e)
        }
    })
}

export const setFiles = function (payload) {
    console.log("utils payload", payload)
    return new Promise(async (resolve, reject) => {
        try {
            const docRef = await addDoc(collection(db, "customers", payload.customerId, "files"), payload.body);
            resolve({...payload.body, id: docRef.id})
        } catch (e) {
            reject(e)
        }
    })
}

// Delete Docs
export const deleteFire = function (payload) {
    return new Promise(async (resolve, reject) => {
        try {
            await deleteDoc(doc(db, payload.collection, payload.doc));
            resolve()
        } catch (e) {
            reject(e)
        }
    })
}

// Delete Docs
export const deleteFile = function (payload) {
    return new Promise(async (resolve, reject) => {
        try {
            await deleteDoc(doc(db, "customers", payload.customerId, "files", payload.fileId));
            resolve()
        } catch (e) {
            reject(e)
        }
    })
}

// Custom Functions
// For getting more complex docs with multiple where clauses
export const GetReminderCalls = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, "jobs")
            // , where("status", "!=", "COMPLETE")
            , where("callFrequency", "==", "daily")
            , where("active", "==", true)
            );
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getFiles = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, "customers", payload.customerId, "files"));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}


export const getProjectByCustomerId = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, "projects")
            // , where("status", "!=", "COMPLETE")
            , where("customerId", "==", payload.customerId)
            );
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}


export const GetRemindersByFriday = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, "jobs")
            // , where("status", "!=", "COMPLETE")
            , where("callFrequency", "==", "friday")
            , where("active", "==", true)
            );
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const GetRemindersByDay = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
const startOfToday = payload.start 
const endOfToday = payload.end

            const q = query(collection(db, "reminders")
            // , where("status", "!=", "COMPLETE")
            , where("reminderDate", ">=", startOfToday)
            , where("reminderDate", "<=", endOfToday)
            , orderBy("reminderDate", 'asc')
            );
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}


export const getLatestJob = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{

            const q = query(collection(db, "jobs")
            , orderBy("projectId", 'desc')
            , limit(1)
            );
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr[0])
        } catch(e){
            reject(e)
        }
    })
}

export const getDocsByUser = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, payload.collection), where("userId", "==", payload.userId));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getJobsByProjectId = function (payload) {
  return new Promise(async (resolve, reject) => {
    try {
      // Only parseInt if payload is a string
      const t = typeof payload === "string" ? parseInt(payload, 10) : payload;

      const q = query(collection(db, "jobs"), where("projectId", "==", t));
      const querySnapshot = await getDocs(q);

      let arr = [];
      let hasCompleted = false;
      let hasCancelled = false;

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const status = data.status;

        if (status === "COMPLETED") {
          if (!hasCompleted) {
            arr.push({ ...data, id: doc.id });
            hasCompleted = true;
          }
        } else if (status === "CANCELLED") {
          if (!hasCancelled) {
            arr.push({ ...data, id: doc.id });
            hasCancelled = true;
          }
        } else {
          arr.push({ ...data, id: doc.id });
        }
      });

      resolve(arr);
    } catch (e) {
      reject(e);
    }
  });
};



export const getJobsByCustomerId = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, "jobs"), where("customerId", "==", payload));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getLeads = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"leads"));
            const querySnapshot = await getDocs(q);

            let arr = []
            for (let i = 0; i < querySnapshot.docs.length; i++) {
                const doc = querySnapshot.docs[i];
                arr.push({ ...doc.data(), id: doc.id });
              }

            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}
export const getCrmReminders = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"crmReminders"));
            const querySnapshot = await getDocs(q);

            let arr = []
            for (let i = 0; i < querySnapshot.docs.length; i++) {
                const doc = querySnapshot.docs[i];
                arr.push({ ...doc.data(), id: doc.id });
              }

            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getCustomers = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"customers"), orderBy("company", "asc"));
            const querySnapshot = await getDocs(q);

            let arr = []
            for (let i = 0; i < querySnapshot.docs.length; i++) {
                const doc = querySnapshot.docs[i];
                arr.push({ ...doc.data(), id: doc.id });
              }

            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getClients = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"clients"), orderBy("name", "asc"));
            const querySnapshot = await getDocs(q);

            let arr = []
            for (let i = 0; i < querySnapshot.docs.length; i++) {
                const doc = querySnapshot.docs[i];
                arr.push(doc.data().name);
              }

            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getJobs = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"jobs"));
            const querySnapshot = await getDocs(q);

            let arr = []
            for (let i = 0; i < querySnapshot.docs.length; i++) {
                const doc = querySnapshot.docs[i];
                arr.push({...doc.data(), id: doc.id});
              }

            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getUsers = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"users"), orderBy("name", "asc"));
            const querySnapshot = await getDocs(q);

            let arr = []
            for (let i = 0; i < querySnapshot.docs.length; i++) {
                const doc = querySnapshot.docs[i];
                arr.push({ ...doc.data(), id: doc.id });
              }

            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getProjects = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"jobs"), where("company", "==", payload.companyName), where("active", "==", true));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}


export const getProjectsByClient = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"projects"), where("customerId", "==", payload.customerId), where("active", "==", true));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}


export const getReminders = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db,"reminders"), where("projectId", "==", payload.projectId), orderBy('created'));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}
export const getContractors = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            // Just get contractors
            // const q = query(collection(db,"users"), where("role", "==", "contractor"), orderBy("name", "asc"));
            // get all team used to allocate jobs to testers and admin
            const q = query(collection(db,"users"), orderBy("name", "asc"));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getTeamLeaders = function () {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(collection(db, "users"), where("isTeamLeader", "==", true));
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((doc) => {
                arr.push({ ...doc.data(), id: doc.id });
            });
            arr.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

// A tester can report to several team leaders. Newer user docs store the
// array `teamLeaderIds`; docs written before that store a single
// `teamLeaderId` string. Read both and merge until the data is backfilled.
export const userTeamLeaderIds = function (user) {
    if (!user) return [];
    if (Array.isArray(user.teamLeaderIds)) return user.teamLeaderIds;
    return user.teamLeaderId ? [user.teamLeaderId] : [];
}

export const getTeamMembers = function (teamLeaderId) {
    return new Promise(async (resolve, reject) => {
        try {
            const [legacySnap, snap] = await Promise.all([
                getDocs(query(collection(db, "users"), where("teamLeaderId", "==", teamLeaderId))),
                getDocs(query(collection(db, "users"), where("teamLeaderIds", "array-contains", teamLeaderId))),
            ]);
            const byId = {};
            legacySnap.forEach((doc) => { byId[doc.id] = { ...doc.data(), id: doc.id }; });
            snap.forEach((doc) => { byId[doc.id] = { ...doc.data(), id: doc.id }; });
            const arr = Object.values(byId);
            arr.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getTodaysJobsByTeamLeader = function (teamLeaderId) {
    return new Promise(async (resolve, reject) => {
        try {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);

            const q = query(
                collection(db, "jobs"),
                where("teamLeaderIds", "array-contains", teamLeaderId)
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                const jobDate = data.date && data.date.toDate ? data.date.toDate() : new Date(data.date);
                if (jobDate >= today && jobDate < tomorrow) {
                    arr.push({ ...data, id: doc.id });
                }
            });
            arr.sort((a, b) => {
                const da = a.date && a.date.toDate ? a.date.toDate() : new Date(a.date);
                const db2 = b.date && b.date.toDate ? b.date.toDate() : new Date(b.date);
                return da - db2;
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}
export const createTeamLeaderInvite = async function (teamLeaderId, jobId, jobDetails) {
    // Resolved here rather than at the four call sites so none of them can
    // forget to pass it. `meters` stays for invites already sitting as pending.
    const defs = await loadDefinitions();
    const customFields = defs.enabled
        ? resolveFieldValues(defs, jobDetails, 'tester').map(f => ({ label: f.label, value: String(f.value) }))
        : [];

    return postFire({
        collection: 'teamLeaderInvites',
        body: {
            teamLeaderId,
            jobId,
            company: jobDetails.company || '',
            projectName: jobDetails.projectName || '',
            date: jobDetails.date || '',
            fullAddress: jobDetails.fullAddress || jobDetails.formattedAddress || '',
            meters: jobDetails.meters || '',
            tester: jobDetails.tester || '',
            customFields,
            status: 'pending',
            createdAt: new Date(),
        }
    });
}

export const getDocsOrderByCompany = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, payload.collection), orderBy("company", "asc"));
            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

export const getJobsByDate = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{

            let q 
            if(payload.tester){
                // Show result only where contactor is equal to payload.tester
                // also testers can only see published jobs
                q = query(collection(db, payload.collection), 
            where('date', '>', payload.dateFrom),
            where('date', '<', payload.dateTo),
            where('contractor.id', '==', payload.tester),
            where('published', '==', true),
            orderBy("date"));
            } else {
                q = query(collection(db, payload.collection), 
            where('date', '>', payload.dateFrom),
            where('date', '<', payload.dateTo),
            orderBy("date"));
            }
            

            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}
export const getJobsByDateAndContractor = function (payload) {
    return new Promise(async (resolve, reject) => {
        try{
            const q = query(collection(db, payload.collection), 
            where('date', '>', payload.dateFrom),
            where('date', '<', payload.dateTo),
            where('contractor.id', '==', payload.contractorId),
            orderBy("date"));

            const querySnapshot = await getDocs(q);

            let arr = []
            querySnapshot.forEach((doc) => {
                arr.push({...doc.data(), id: doc.id})
            });
            resolve(arr)
        } catch(e){
            reject(e)
        }
    })
}

// Authentication
//Reset
export const resetPassword = function (payload) {
    return new Promise(async (resolve, reject) => {
        sendPasswordResetEmail(auth, payload.email)
            .then(() => {
                // Signed in 
                resolve()
            })
            .catch((error) => {
                reject(error)
            });
    })
}

export const signUp = function (payload) {
    return new Promise(async (resolve, reject) => {
        createUserWithEmailAndPassword(auth, payload.email, payload.password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                resolve(user)
            })
            .catch((error) => {
                reject(error)
            });
    })
}

// SignIn
export const signIn = function (payload) {
    return new Promise(async (resolve, reject) => {
        signInWithEmailAndPassword(auth, payload.email, payload.password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                resolve(user)
            })
            .catch((error) => {
                reject(error)
            });
    })
}

export const signMeOut = function (payload) {
    return new Promise(async (resolve, reject) => {
        signOut(auth).then(() => {
            console.log('User signed out!');
            resolve()
          }).catch((error) => {
            console.error('Error signing out:', error);
            reject()
          });
    })
}

export const listenToState = function () {
    return new Promise(async (resolve, reject) => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in
                const uid = user.uid;
                resolve(uid)
            } else {
                console.log("UID", user)
                reject()
            }
        });
    })
}

// Storage

export const upload = function (payload){
    return new Promise(async (resolve, reject) => {
        const storageRef = ref(storage, payload.child);

        uploadString(storageRef, payload.base, 'base64').then((snapshot) => {
            resolve(snapshot)
        }).catch(e => {
            reject(e)
        })

    })
}

// ── Vehicle / Fleet Functions ──

const VEHICLES_API = 'https://us-central1-ktc-app-33f33.cloudfunctions.net/widgets/api/v1/vehicles';

// Fetch vehicles via API (avoids direct Firestore reads)
export const fetchVehicles = async function () {
    const user = auth.currentUser;
    if (!user) throw new Error('Not authenticated');
    const token = await user.getIdToken();
    const res = await fetch(VEHICLES_API, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) throw new Error(`Vehicles request failed: ${res.status}`);
    const json = await res.json();
    return json.data || json || [];
}

// Poll vehicles at an interval, calling callback with updated list.
// Returns a stop function (like onSnapshot unsubscribe).
export const pollVehicles = function (callback, intervalMs = 10000) {
    let active = true;
    async function poll() {
        if (!active) return;
        try {
            const vehicles = await fetchVehicles();
            if (active) callback(vehicles);
        } catch (e) {
            console.error('Vehicle poll error:', e.message);
        }
    }
    poll(); // immediate first fetch
    const timer = setInterval(poll, intervalMs);
    return function stop() {
        active = false;
        clearInterval(timer);
    };
}

// Real-time listener on vehicles collection (deprecated — use pollVehicles instead)
export const onVehiclesSnapshot = function (callback) {
    const q = query(collection(db, "vehicles"));
    return onSnapshot(q, (snapshot) => {
        let arr = [];
        snapshot.forEach((doc) => {
            arr.push({ ...doc.data(), id: doc.id });
        });
        callback(arr);
    });
}

// One-time fetch of all vehicles (via API)
export const getVehicles = async function () {
    return fetchVehicles();
}

// Assign vehicle to a user (batch write: updates both vehicles and users docs)
export const assignVehicleToUser = function (vehicleId, userId, userName) {
    return new Promise(async (resolve, reject) => {
        try {
            const batch = writeBatch(db);
            const vehicleRef = doc(db, "vehicles", vehicleId);
            const userRef = doc(db, "users", userId);
            batch.update(vehicleRef, {
                assignedUserId: userId,
                assignedUserName: userName
            });
            batch.update(userRef, {
                assignedVehicleId: vehicleId
            });
            await batch.commit();
            resolve();
        } catch (e) {
            reject(e);
        }
    });
}

// Unassign vehicle from user (batch write)
export const unassignVehicle = function (vehicleId, userId) {
    return new Promise(async (resolve, reject) => {
        try {
            const batch = writeBatch(db);
            const vehicleRef = doc(db, "vehicles", vehicleId);
            batch.update(vehicleRef, {
                assignedUserId: null,
                assignedUserName: null
            });
            if (userId) {
                const userRef = doc(db, "users", userId);
                batch.update(userRef, {
                    assignedVehicleId: null
                });
            }
            await batch.commit();
            resolve();
        } catch (e) {
            reject(e);
        }
    });
}

// Get vehicle position history via Cloud Functions API (reads from Traccar, not Firestore)
export const getVehiclePositionHistory = async function (vehicleId, hoursBack, dateStr) {
    const user = auth.currentUser;
    if (!user) throw new Error('Not authenticated');
    const token = await user.getIdToken();

    let url;
    if (dateStr) {
        // dateStr is YYYY-MM-DD — fetch full day (00:00 to 23:59:59)
        const from = new Date(dateStr + 'T00:00:00');
        const to = new Date(dateStr + 'T23:59:59');
        url = `https://us-central1-ktc-app-33f33.cloudfunctions.net/widgets/api/v1/vehicles/${vehicleId}/positions?from=${from.toISOString()}&to=${to.toISOString()}`;
    } else {
        const hours = hoursBack || 24;
        url = `https://us-central1-ktc-app-33f33.cloudfunctions.net/widgets/api/v1/vehicles/${vehicleId}/positions?hoursBack=${hours}`;
    }

    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error(`Position history request failed: ${res.status}`);
    const json = await res.json();
    return json.data || json || [];
}

// Get vehicle events (overspeed, harsh braking, etc.)
export const getVehicleEvents = function (vehicleId, maxResults) {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(
                collection(db, "vehicleEvents"),
                where("vehicleId", "==", vehicleId),
                orderBy("timestamp", "desc"),
                limit(maxResults || 20)
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((doc) => {
                arr.push({ ...doc.data(), id: doc.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

// Get driver scores for a user
export const getDriverScores = function (userId) {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(
                collection(db, "driverScores"),
                where("userId", "==", userId),
                orderBy("date", "desc"),
                limit(7)
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((doc) => {
                arr.push({ ...doc.data(), id: doc.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

// Remove a vehicle (deletes doc and unassigns user if needed)
export const removeVehicle = function (vehicleId, assignedUserId) {
    return new Promise(async (resolve, reject) => {
        try {
            const batch = writeBatch(db);
            const vehicleRef = doc(db, "vehicles", vehicleId);
            batch.delete(vehicleRef);
            if (assignedUserId) {
                const userRef = doc(db, "users", assignedUserId);
                batch.update(userRef, { assignedVehicleId: null });
            }
            await batch.commit();
            resolve();
        } catch (e) {
            reject(e);
        }
    });
}

// Get today's jobs for a contractor
export const getNextJobNumber = async function () {
    const q = query(
        collection(db, "jobs"),
        orderBy("jobNumber", "desc"),
        limit(1)
    );
    const snap = await getDocs(q);
    let next = 1;
    if (!snap.empty) {
        const current = parseInt(snap.docs[0].data().jobNumber, 10);
        if (!isNaN(current)) next = current + 1;
    }
    return String(next).padStart(4, '0');
}

// ── CRM Functions ──

export const getRegions = function () {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(collection(db, "regions"), orderBy("name", "asc"));
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((d) => {
                arr.push({ ...d.data(), id: d.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getCrmNotes = function (leadId) {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(
                collection(db, "crmNotes"),
                where("leadId", "==", leadId),
                orderBy("created", "desc")
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((d) => {
                arr.push({ ...d.data(), id: d.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getClientNotes = function (customerId) {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(
                collection(db, "crmNotes"),
                where("customerId", "==", customerId),
                where("isClientNote", "==", true),
                orderBy("created", "desc")
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((d) => {
                arr.push({ ...d.data(), id: d.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getRemindersByUser = function (userId) {
    return new Promise(async (resolve, reject) => {
        try {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);
            const todayStr = today.toISOString().split('T')[0];

            const q = query(collection(db, "crmReminders"));
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((d) => {
                const data = d.data();
                const reminderDate = data.date ? data.date.split('T')[0] : '';
                const isForUser = (data.createdBy && data.createdBy.id === userId) ||
                                  (data.assignedTo && data.assignedTo.id === userId);
                if (isForUser && reminderDate <= todayStr && !data.dismissed) {
                    arr.push({ ...data, id: d.id });
                }
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getAdminUsers = function () {
    return new Promise(async (resolve, reject) => {
        try {
            const q = query(collection(db, "users"), where("role", "==", "admin"), orderBy("name", "asc"));
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((d) => {
                arr.push({ ...d.data(), id: d.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

export const getTodaysJobsByContractor = function (contractorId) {
    return new Promise(async (resolve, reject) => {
        try {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);

            const q = query(
                collection(db, "jobs"),
                where("contractor.id", "==", contractorId),
                where("date", ">", today),
                where("date", "<", tomorrow),
                orderBy("date", "asc")
            );
            const querySnapshot = await getDocs(q);
            let arr = [];
            querySnapshot.forEach((doc) => {
                arr.push({ ...doc.data(), id: doc.id });
            });
            resolve(arr);
        } catch (e) {
            reject(e);
        }
    });
}

